module.exports = __webpack_public_path__ + "static/media/whatsapp.919f3dda.svg";